import Vec2 from 'vec2';

import { OFFSET_MEASUREMENT_TEXT, QUARTER_PART_NAME } from '~/core/constants';

const getQuarterPart = (vec: Vec2): string => {
  let partName = '';
  const { x, y } = vec;

  if (Math.abs(y) < Math.abs(x) * 0.0875) {
    if (x >= 0) {
      partName = QUARTER_PART_NAME.POS_X_AXIS;
    } else if (x < 0) {
      partName = QUARTER_PART_NAME.NEG_X_AXIS;
    }
  } else if (Math.abs(x) < Math.abs(y) * 0.0875) {
    if (y >= 0) {
      partName = QUARTER_PART_NAME.POS_Y_AXIS;
    } else if (y < 0) {
      partName = QUARTER_PART_NAME.NEG_Y_AXIS;
    }
  } else if (x > 0 && y < 0) {
    partName = QUARTER_PART_NAME.QUARTER_1;
  } else if (x > 0 && y > 0) {
    partName = QUARTER_PART_NAME.QUARTER_2;
  } else if (x < 0 && y > 0) {
    partName = QUARTER_PART_NAME.QUARTER_3;
  } else {
    partName = QUARTER_PART_NAME.QUARTER_4;
  }

  return partName;
};

export const getCornerLabelPosition = (
  beforePos: Vec2,
  currentPos: Vec2,
  afterPos: Vec2,
  textW: number,
  textH: number
): Vec2 => {
  let pos = new Vec2(0, 0);

  // use before and after vectors of the current vector to get the sum of the 2 vectors
  // this sum will give the direction  of the corner measurement

  const beforeVec = currentPos.subtract(beforePos, true).normalize();
  const afterVec = currentPos.subtract(afterPos, true).normalize();

  const dirVec = beforeVec.add(afterVec, true).normalize();

  const normalVec = beforeVec.rotate(Math.PI / 2, undefined, true);

  if (normalVec.x * dirVec.x + normalVec.y * dirVec.y < 0) {
    dirVec.multiply(-1);
  }

  const diffVec = dirVec.multiply(OFFSET_MEASUREMENT_TEXT, true);

  pos = currentPos.add(diffVec, true);

  const partName = getQuarterPart(dirVec);

  // shift the corner measurement depending in which quarters the initial point is
  switch (partName) {
    case QUARTER_PART_NAME.POS_X_AXIS:
      pos.set(pos.x, pos.y - textH * 1.5, false);
      break;
    case QUARTER_PART_NAME.NEG_X_AXIS:
      pos.set(pos.x - textW, pos.y - textH * 1.5, false);
      break;
    case QUARTER_PART_NAME.POS_Y_AXIS:
      pos.set(pos.x - textW, pos.y, false);
      break;
    case QUARTER_PART_NAME.NEG_Y_AXIS:
      pos.set(pos.x - textW, pos.y - textH, false);
      break;
    case QUARTER_PART_NAME.QUARTER_1:
      pos.set(pos.x + textW * 0.25, pos.y - textH * 0.66, false);
      break;
    case QUARTER_PART_NAME.QUARTER_2:
      pos.set(pos.x + textW * 0.25, pos.y, false);
      break;
    case QUARTER_PART_NAME.QUARTER_3:
      pos.set(pos.x - textW * 0.75, pos.y, false);
      break;
    case QUARTER_PART_NAME.QUARTER_4:
      pos.set(pos.x - textW * 0.75, pos.y - textH * 0.66, false);
      break;
    default:
      break;
  }

  return pos;
};
